import { Banner } from '@versita/frontend/campus-ui-web';
import { useEffect } from 'react';

/**
 * Shows a warning about code sharing on timetables. Hidden after being viewed 3 times.
 */
export const CodeShareWarning = () => {
  const seenCount = parseInt(
    localStorage.getItem('CodeShareBannerSeen') || '0',
  );
  useEffect(() => {
    if (seenCount <= 3) {
      localStorage.setItem('CodeShareBannerSeen', `${seenCount + 1}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return seenCount > 3 ? null : (
    <Banner>
      Code sharing is classed as a breach of the{' '}
      <a
        href="https://testlivesalfordac.sharepoint.com/:b:/r/sites/ProjectDelivery/Shared%20Documents/In-flight%20Projects/StEP%20-%20Student%20Engagement%20Platform/11.%20User%20Guidance%20Docs/Induction/Code%20Sharing%20Guidance/StEP%20Code%20Sharing%20WRI%20Slides%20v6%20-%20Timetabling%20App.pdf?csf=1&amp;web=1&amp;e=IT8cbh"
        rel="noreferrer"
        target="_blank"
      >
        student code of conduct
      </a>
      . <strong>Be there, don't share.</strong>
    </Banner>
  );
};

export default CodeShareWarning;
